import React, { useEffect, useState, useMemo, useRef } from 'react'
import { connect, useSelector, useDispatch } from 'react-redux'
import { useHistory, Link } from 'react-router-dom'
import { compose } from 'redux'
import axios from 'axios'
import moment from 'moment'
import ModalConfirm from '../../components/ModalConfirm/index.js'
import { deleteSimuPlayerSaga, refreshSimuPlayersSaga, getSimuPlayersSaga, createArchivePlayerSaga, getDashboardSaga } from './saga'
import injectSaga from '../../utils/injectSaga'
import { deleteSimuPlayer, createArchivePlayer, getSimuPlayers } from '../App/actions'
import {
  Bg, Loader,
  FirstContainer, ContainerFirstStudent, AvatarContainer, TextFirstCSV,
  EmptyStateCard, EmptyStateIcon, EmptyStateSubText,
  StatusSelector, LicenceSelector,
  // modern table
  TablePageLayout, FilterRow, FilterField, FilterFieldLabel, FilterSearchBox, FilterIconBtn, InlineDateFilter,
  TableCard, TableScroll, StyledTable, STHead, STH, STBody, STR, STD,
  PlayerCellWrapper, InitialBubble, PlayerRowLink, PlayerRowSpan,
  PermisTag, EvalScoreLink, StatusTag2, TransferChip,
  FormationList, FormationChip, MoreChip, NoneText,
  TableActions2, TActionBtn, AgencyCellLink,
  ButtonImport, ButtonCreate, ImportImg, ImportText,
} from './styledComponents'
import PageHeader from '../../components/PageHeader'
import studentIcon from '../../images/StudentImage.svg'
import Avatar4 from '../../images/Avatar4.svg'
import AddStudent from '../../images/AddStudent.svg'
import config from '../../config/configurator'
import UiEdit from '../../images/edit.svg'
import UiDelRed from '../../images/closeRed.svg'
import UiArchive from '../../images/Archive.svg'
import ModalArchive from '../../components/ModalArchive'
import SearchIcon from '../../images/search.svg'
import ResetIcon from '../../images/delete.svg'

const isB2VM  = process.env.REACT_APP_TYPE === 'b2vm'
const apiBase = process.env.REACT_APP_TGDAPI_SERVER || ''

const getInitials = (name = '') => {
  const parts = name.trim().split(/\s+/)
  if (parts.length === 1) return (parts[0]?.[0] || '?').toUpperCase()
  return ((parts[0]?.[0] || '') + (parts[parts.length - 1]?.[0] || '')).toUpperCase()
}

const SimuPlayers = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const simuPlayers    = useSelector(s => s.toJS().global.simuPlayers    || [])
  const agencies       = useSelector(s => s.toJS().global.agencies)
  const agencytoken    = useSelector(s => s.toJS().global.agencytoken)
  const agencyid       = useSelector(s => s.toJS().global.agencyid)
  const isAdmin        = useSelector(s => s.toJS().global.isAdmin)
  const loading        = useSelector(s => s.toJS().global.loading)
  const dashboardData  = useSelector(s => s.toJS().global.dashboard       || {})
  const totalSimuPlayers = useSelector(s => s.toJS().global.totalSimuPlayers)
  const pageSize       = useSelector(s => s.toJS().global.pageSize        || 50)
  const allSessions    = useSelector(s => s.toJS().global.sessions        || [])
  const orders         = useSelector(s => s.toJS().global.orders          || [])

  const [showArchiveModal,   setShowArchiveModal]   = useState(false)
  const [actualDrivingTotal, setActualDrivingTotal] = useState('')
  const [licenceDate,        setLicenceDate]        = useState('')
  const [licenceAttempts,    setLicenceAttempts]    = useState('')
  const [showModal,    setShowModal]    = useState(false)
  const [modalText,    setModalText]    = useState('')
  const [modalName,    setModalName]    = useState('')
  const [playerId,     setPlayerId]     = useState('')
  const [filters,      setFilters]      = useState({ students: '', email: '', licence: 'all', date: '', status: 'all', formation: 'all' })
  const [agencyFilter, setAgencyFilter] = useState('')
  const [appliedAgencyFilter, setAppliedAgencyFilter] = useState('')
  const [activatedButton, setActivatedButton] = useState(false)
  const [appliedFormation, setAppliedFormation] = useState('all')
  const [searchExecuted, setSearchExecuted] = useState(false)

  useEffect(() => {
    if (!agencytoken) return
    dispatch(getSimuPlayers(filters, agencies, agencytoken, pageSize, 0))
  // eslint-disable-next-line
  }, [agencytoken, pageSize])

  // ── Formation data ──────────────────────────────────────────────
  const orderMap = useMemo(() => {
    if (isAdmin) return {}
    const map = {}
    orders.forEach(o => { map[o._id] = o })
    return map
  }, [orders, isAdmin])

  const playerFormationsMap = useMemo(() => {
    if (isAdmin) return {}
    const map = {}
    allSessions.forEach(session => {
      if (!session.studentId) return
      const order = orderMap[session.orderId]
      const item  = order?.items?.[session.orderItemIndex]
      if (!item?.name) return
      if (!map[session.studentId]) map[session.studentId] = []
      if (!map[session.studentId].includes(item.name)) map[session.studentId].push(item.name)
    })
    return map
  }, [allSessions, orderMap, isAdmin])

  const [adminFormationsMap, setAdminFormationsMap] = useState({})
  const lastAdminAgencyKeyRef = useRef('')

  const clearAdminFormations = () => {
    lastAdminAgencyKeyRef.current = ''
    setAdminFormationsMap(previousMap => (
      Object.keys(previousMap).length === 0 ? previousMap : {}
    ))
  }

  useEffect(() => {
    if (isAdmin) {
      clearAdminFormations()
      return
    }

    if (!agencytoken || simuPlayers.length === 0) {
      clearAdminFormations()
      return
    }

    const uniqueAgencyIds = [...new Set(simuPlayers.map(player => player.agencyId).filter(Boolean))]
    if (uniqueAgencyIds.length === 0) {
      clearAdminFormations()
      return
    }

    const agencyKey = [...uniqueAgencyIds].sort().join('|')
    if (lastAdminAgencyKeyRef.current === agencyKey) return
    lastAdminAgencyKeyRef.current = agencyKey

    let isCancelled = false

    const loadAdminFormations = async () => {
      try {
        const results = await Promise.all(uniqueAgencyIds.map(async agencyId => {
          const [sessionsRes, ordersRes] = await Promise.all([
            axios.get(`${apiBase}/sessions?agencyId=${agencyId}`, {
              headers: { Authorization: `Bearer ${agencytoken}` },
            }),
            axios.get(`${apiBase}/order?agencyId=${agencyId}`, {
              headers: { Authorization: `Bearer ${agencytoken}` },
            }),
          ])

          const sessions = Array.isArray(sessionsRes.data)
            ? sessionsRes.data
            : (sessionsRes.data?.sessions || [])

          const ordersData = Array.isArray(ordersRes.data)
            ? ordersRes.data
            : (ordersRes.data?.orders || [])

          return { sessions, ordersData }
        }))

        if (isCancelled) return

        const oMap = {}
        const fMap = {}

        results.forEach(({ sessions, ordersData }) => {
          ordersData.forEach(order => { oMap[order._id] = order })
          sessions.forEach(session => {
            if (!session.studentId) return
            const order = oMap[session.orderId]
            const item = order?.items?.[session.orderItemIndex]
            if (!item?.name) return
            if (!fMap[session.studentId]) fMap[session.studentId] = []
            if (!fMap[session.studentId].includes(item.name)) fMap[session.studentId].push(item.name)
          })
        })

        setAdminFormationsMap(fMap)
      } catch (error) {
        if (!isCancelled) setAdminFormationsMap({})
      }
    }

    loadAdminFormations()

    return () => {
      isCancelled = true
    }
  }, [isAdmin, agencytoken, simuPlayers])

  // ── Helpers ─────────────────────────────────────────────────────
  function findAgencyName(agencyId) {
    if (agencies == null) return ''
    if (agencyId == null) return 'Non affilié'
    const agency = isB2VM
      ? agencies.find(a => a.agencyId === agencyId)
      : agencies.find(a => a.id === agencyId)
    return agency != null ? agency.agencyname || agency.agencyName : 'Aucune agence'
  }

  function convertInTime(time) {
    if (time) {
      const h = parseInt(time / 60 / 60)
      const m = parseInt(time / 60 % 60)
      const s = parseInt(time % 60)
      return h + 'h ' + m + 'm' + s + 's'
    }
    return 'Non démarré'
  }

  function confirmDelete(id, action, firstname) {
    setShowModal(true); setPlayerId(id)
    setModalText(action); setModalName(firstname)
  }

  const confirmArchivePlayer = (id, name) => {
    setShowArchiveModal(true); setModalName(name); setPlayerId(id)
  }

  function deletePlayer(id) {
    dispatch(deleteSimuPlayer(agencytoken, id, agencyid))
    setTimeout(() => dispatch(getSimuPlayers(filters, agencies, agencytoken, pageSize, 0)), 500)
  }

  const archivePlayer = (id) => {
    dispatch(createArchivePlayer({
      agencyToken: agencytoken,
      studentId: id,
      actualDrivingTotal,
      licenceDate: moment(licenceDate).toISOString(),
      licenceAttempts,
    }))
    setTimeout(() => history.push('/simuplayers/archive'), 10)
  }

  // ── Build rows ──────────────────────────────────────────────────
  const buildRows = () => {
    if (loading) return []
    return simuPlayers.map(player => {
      const { prog } = player
      const pTime   = prog ? convertInTime(prog.PlayTime) : 0
      const pCount  = prog?.Completion?.Count      || 0
      const pTotal  = prog?.Completion?.CountTotal || 0
      const pLicence = isB2VM
        ? player.trainingType
        : player.TrainingType === '1' ? 'B'
        : player.TrainingType === '2' ? 'BEA'
        : player.TrainingType === '3' ? 'AAC'
        : ''
      return {
        eleve:    `${player.firstname} ${player.lastname}`,
        email:    player.email,
        agence:   findAgencyName(player.agencyId),
        agencyId: player.agencyId,
        permis:   pLicence,
        conduite: pTime,
        id:       player.id || player._id,
        eval:     player.evalHours || player.evaluationScore || player.evalScore || '',
        date:     moment(player.dateCreation).format('DD/MM/YYYY'),
        pCount,
        pTotal,
        status:   player.status,
      }
    })
  }

  // ── Filter selectors ────────────────────────────────────────────
  const licenceArray = [
    { value: 'all', label: 'Tous' },
    { value: 'B',       label: 'B' },
    { value: 'BEA',     label: 'BEA' },
    { value: 'AAC',     label: 'AAC' },
    { value: 'BEA AAC', label: 'BEA AAC' },
  ]

  const DisplayLicenceSelector = () => (
    <div style={{ zIndex: 1 }}>
      <LicenceSelector
        classNamePrefix='react-select'
        multiple={false}
        isSearchable={false}
        value={licenceArray.value}
        defaultValue={
          filters.licence === 'B'       ? licenceArray[1] :
          filters.licence === 'BEA'     ? licenceArray[2] :
          filters.licence === 'AAC'     ? licenceArray[3] :
          filters.licence === 'BEA AAC' ? licenceArray[4] :
          licenceArray[0]
        }
        onChange={e => handleClickFilters(e, 'licence')}
        options={licenceArray}
      />
    </div>
  )

  const allFormationNames = useMemo(() => {
    if (isAdmin) return []
    const names = new Set()
    const map = playerFormationsMap
    Object.values(map).forEach(fms => fms.forEach(f => names.add(f)))
    return [...names].sort()
  }, [isAdmin, playerFormationsMap])

  const DisplayFormationSelector = () => {
    const options = [
      { value: 'all', label: 'Toutes' },
      ...allFormationNames.map(f => ({ value: f, label: f })),
    ]
    const current = options.find(o => o.value === filters.formation) || options[0]
    return (
      <div style={{ zIndex: 1 }}>
        <StatusSelector
          classNamePrefix='react-select'
          multiple={false}
          isSearchable={false}
          value={current}
          onChange={e => handleClickFilters(e, 'formation')}
          options={options}
        />
      </div>
    )
  }

  const statusArray = [
    { value: 'all',    label: 'Tous' },
    { value: 'Actif',  label: 'Actif' },
    { value: 'Inactif',label: 'Inactif' },
  ]

  const DisplayStatusSelector = () => (
    <div style={{ zIndex: 1 }}>
      <StatusSelector
        classNamePrefix='react-select'
        multiple={false}
        isSearchable={false}
        value={statusArray.value}
        defaultValue={
          filters.status === 'Actif'   ? statusArray[1] :
          filters.status === 'Inactif' ? statusArray[2] :
          statusArray[0]
        }
        onChange={e => handleClickFilters(e, 'status')}
        options={statusArray}
      />
    </div>
  )


  const totalUnarchivedPlayers = (totalSimuPlayers || 0) - (dashboardData.totalArchiveStudents || 0)
  const handleClickFilters = (e, type) => {
    const value = e?.target !== undefined ? e.target.value : e.value
    setFilters(prev => ({ ...prev, [type]: value }))
    setActivatedButton(true)
  }

  const handleClickFindSimuPlayers = () => {
    dispatch(getSimuPlayers(filters, agencies, agencytoken, pageSize, 0))
    setAppliedFormation(filters.formation)
    setAppliedAgencyFilter(agencyFilter)
    setSearchExecuted(true)
    const hasFilters = filters.students || filters.email || filters.licence !== 'all' || filters.date || filters.status !== 'all' || (!isAdmin && filters.formation !== 'all')
    const isAllSelected = filters.status === 'all' || filters.licence === 'all'
    setActivatedButton(hasFilters && isAllSelected)
  }

  const resetFilters = () => {
    const empty = { students: '', email: '', licence: 'all', date: '', status: 'all', formation: 'all' }
    setFilters(empty)
    setAgencyFilter('')
    setAppliedAgencyFilter('')
    setAppliedFormation('all')
    setSearchExecuted(false)
    dispatch(getSimuPlayers(empty, agencies, agencytoken, pageSize, 0))
    setActivatedButton(false)
  }

  const rows = useMemo(() => {
    if (loading) return []
    let result = buildRows()
    if (!isAdmin && appliedFormation !== 'all') {
      result = result.filter(row => {
        const fms = playerFormationsMap[row.id] || []
        return fms.includes(appliedFormation)
      })
    }
    if (appliedAgencyFilter.trim()) {
      const q = appliedAgencyFilter.trim().toLowerCase()
      result = result.filter(row => (row.agence || '').toLowerCase().includes(q))
    }
    return result
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [simuPlayers, loading, appliedFormation, playerFormationsMap, appliedAgencyFilter, isAdmin])

  // ── Loading state ───────────────────────────────────────────────
  if (!agencytoken || loading === true) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <Loader />
      </div>
    )
  }

  const NoStudents = () => (
    <FirstContainer>
      <ContainerFirstStudent>
        <AvatarContainer>
          <img alt='avatar' src={Avatar4} />
        </AvatarContainer>
        <TextFirstCSV>Vous pouvez <b>créer un élève</b> dans votre console de gestion</TextFirstCSV>
        <ButtonImport>
          <ButtonCreate to='/simuplayers/create' style={{ width: '173px' }}>
            <ImportImg src={AddStudent} />
            <ImportText>Créer un élève</ImportText>
          </ButtonCreate>
        </ButtonImport>
      </ContainerFirstStudent>
    </FirstContainer>
  )

  const FilteredEmpty = () => (
    <FirstContainer>
      <EmptyStateCard>
        <EmptyStateIcon aria-hidden='true'>?</EmptyStateIcon>
        <TextFirstCSV>Aucun élève ne correspond à la recherche.</TextFirstCSV>
        <EmptyStateSubText>Essayez de modifier un ou plusieurs filtres, puis relancez la recherche.</EmptyStateSubText>
      </EmptyStateCard>
    </FirstContainer>
  )

  return (
    <Bg>

      {/* ── Page header ── */}
      <PageHeader
        icon={studentIcon}
        title='Élèves'
        subtitle={`${totalUnarchivedPlayers} élève${totalUnarchivedPlayers > 1 ? 's' : ''}`}
      />

      <TablePageLayout>

        {/* ── Filter bar ── */}
        <FilterRow>
          <FilterField>
            <FilterFieldLabel>Élève</FilterFieldLabel>
            <FilterSearchBox>
              <img src={SearchIcon} alt='' />
              <input
                onChange={e => handleClickFilters(e, 'students')}
                value={filters.students || ''}
                placeholder='Chercher un élève'
              />
            </FilterSearchBox>
          </FilterField>

          <FilterField>
            <FilterFieldLabel>Email</FilterFieldLabel>
            <FilterSearchBox>
              <img src={SearchIcon} alt='' />
              <input
                onChange={e => handleClickFilters(e, 'email')}
                value={filters.email || ''}
                placeholder='Chercher un email'
              />
            </FilterSearchBox>
          </FilterField>

          <FilterField>
            <FilterFieldLabel>Permis</FilterFieldLabel>
            {DisplayLicenceSelector()}
          </FilterField>

          <FilterField>
            <FilterFieldLabel>Statut</FilterFieldLabel>
            {DisplayStatusSelector()}
          </FilterField>

          {isAdmin && (
            <FilterField>
              <FilterFieldLabel>Agence</FilterFieldLabel>
              <FilterSearchBox>
                <img src={SearchIcon} alt='' />
                <input
                  onChange={e => { setAgencyFilter(e.target.value); setActivatedButton(true) }}
                  value={agencyFilter}
                  placeholder='Chercher une agence'
                />
              </FilterSearchBox>
            </FilterField>
          )}

          {!isAdmin && (
            <FilterField>
              <FilterFieldLabel>Formation</FilterFieldLabel>
              {DisplayFormationSelector()}
            </FilterField>
          )}

          <FilterField>
            <FilterFieldLabel>Date</FilterFieldLabel>
            <InlineDateFilter
              value={filters.date || ''}
              type='date'
              onChange={e => handleClickFilters(e, 'date')}
            />
          </FilterField>

          {activatedButton && (
            <FilterIconBtn onClick={handleClickFindSimuPlayers} title='Rechercher'>
              <img src={SearchIcon} alt='' />
            </FilterIconBtn>
          )}
          {activatedButton && (
            <FilterIconBtn onClick={resetFilters} title='Réinitialiser'>
              <img src={ResetIcon} alt='' />
            </FilterIconBtn>
          )}
        </FilterRow>

        {/* ── Table ── */}
        {((searchExecuted || appliedAgencyFilter.trim()) && rows.length === 0) ? <FilteredEmpty /> : (simuPlayers.length === 0) ? <NoStudents /> : (
          <TableCard>
            <TableScroll>
              <StyledTable>
                <STHead>
                  <tr>
                    <STH style={{ width: '18%' }}>Élève</STH>
                    <STH style={{ width: '16%' }}>Email</STH>
                    {isAdmin && <STH style={{ width: '13%' }}>Agence</STH>}
                    <STH style={{ width: '7%',  textAlign: 'center' }}>Permis</STH>
                    {config.features.eval && <STH style={{ width: '6%', textAlign: 'center' }}>Éval</STH>}
                    {config.features.eval && <STH style={{ width: '8%', textAlign: 'center' }}>Date</STH>}
                    {!isAdmin && <STH style={{ width: '18%', textAlign: 'center' }}>Formations</STH>}
                    <STH style={{ width: '10%', textAlign: 'center' }}>Statut</STH>
                    <STH style={{ width: '9%',  textAlign: 'center' }}>Actions</STH>
                  </tr>
                </STHead>
                <STBody>
                  {rows.map(row => {
                    const isActive  = row.status !== 0
                    const canTransfer = !isActive && (config.title === 'ECF' || config.title === 'PP ADMIN')
                    const formations = (isAdmin ? adminFormationsMap : playerFormationsMap)[row.id] || []
                    return (
                      <STR key={row.id} $inactive={!isActive ? 1 : 0}>

                        {/* Élève */}
                        <STD>
                          <PlayerCellWrapper>
                            <InitialBubble>{getInitials(row.eleve)}</InitialBubble>
                            {isActive
                              ? <PlayerRowLink to={`simuplayers/edit/${row.id}`}>{row.eleve}</PlayerRowLink>
                              : <PlayerRowSpan>{row.eleve}</PlayerRowSpan>
                            }
                          </PlayerCellWrapper>
                        </STD>

                        {/* Email */}
                        <STD>
                          <span style={{ fontFamily: 'Poppins', fontSize: '0.8rem', color: '#6B7280', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                            {row.email}
                          </span>
                        </STD>

                        {/* Agence (admin only) */}
                        {isAdmin && (
                          <STD>
                            <AgencyCellLink
                              to={row.agence === 'Aucune agence' ? '#' : `agency/edit/${row.agencyId}`}
                              $inactive={row.agence === 'Aucune agence' ? 1 : 0}
                            >
                              {row.agence}
                            </AgencyCellLink>
                          </STD>
                        )}

                        {/* Permis */}
                        <STD style={{ textAlign: 'center' }}>
                          {row.permis
                            ? <PermisTag>{row.permis}</PermisTag>
                            : <NoneText>—</NoneText>
                          }
                        </STD>

                        {/* Éval */}
                        {config.features.eval && (
                          <STD data-keep-color={row.eval ? 'true' : undefined} style={{ textAlign: 'center' }}>
                            {row.eval ? (
                              <EvalScoreLink
                                to={{ pathname: `/simuplayers/eval/${row.id}`, query: { id: row.id } }}
                              >
                                {row.eval}
                              </EvalScoreLink>
                            ) : (
                              <span style={{ color: '#D1D5DB', fontSize: '0.85rem', fontFamily: 'Poppins' }}>—</span>
                            )}
                          </STD>
                        )}

                        {/* Date */}
                        {config.features.eval && (
                          <STD style={{ textAlign: 'center' }}>
                            <span style={{ fontFamily: 'Poppins', fontSize: '0.8rem', color: '#6B7280', whiteSpace: 'nowrap' }}>
                              {row.date}
                            </span>
                          </STD>
                        )}

                        {/* Formations */}
                        {!isAdmin && (
                          <STD style={{ textAlign: 'center' }}>
                            <FormationList>
                              {formations.length > 0 ? (
                                <>
                                  {formations.slice(0, 2).map(f => (
                                    <FormationChip key={f} title={f}>{f}</FormationChip>
                                  ))}
                                  {formations.length > 2 && <MoreChip>+{formations.length - 2}</MoreChip>}
                                </>
                              ) : (
                                <NoneText>—</NoneText>
                              )}
                            </FormationList>
                          </STD>
                        )}

                        {/* Statut */}
                        <STD data-keep-color={canTransfer ? 'true' : undefined} style={{ textAlign: 'center' }}>
                          {isActive
                            ? <StatusTag2 $active>Actif</StatusTag2>
                            : canTransfer
                              ? <TransferChip to={`simuplayers/transfer/${row.id}`}>Transférer</TransferChip>
                              : <StatusTag2>Inactif</StatusTag2>
                          }
                        </STD>

                        {/* Actions */}
                        <STD style={{ textAlign: 'center' }}>
                          <TableActions2>
                            {isActive
                              ? <TActionBtn as={Link} to={`simuplayers/edit/${row.id}`} title='Modifier'>
                                  <img src={UiEdit} alt='' />
                                </TActionBtn>
                              : <TActionBtn style={{ opacity: 0.25, cursor: 'default', pointerEvents: 'none' }} title='Modifier'>
                                  <img src={UiEdit} alt='' />
                                </TActionBtn>
                            }
                            {!isAdmin && (
                              isActive
                                ? <TActionBtn onClick={() => confirmArchivePlayer(row.id, row.eleve, row.email)} title='Archiver'>
                                    <img src={UiArchive} alt='' />
                                  </TActionBtn>
                                : <TActionBtn style={{ opacity: 0.25, cursor: 'default', pointerEvents: 'none' }} title='Archiver'>
                                    <img src={UiArchive} alt='' />
                                  </TActionBtn>
                            )}
                            <TActionBtn
                              $danger
                              onClick={() => confirmDelete(row.id, 'Attention, vous allez supprimer définitivement le compte de ', row.eleve)}
                              title='Supprimer'
                            >
                              <img src={UiDelRed} alt='' />
                            </TActionBtn>
                          </TableActions2>
                        </STD>

                      </STR>
                    )
                  })}
                </STBody>
              </StyledTable>
            </TableScroll>
          </TableCard>
        )}

      </TablePageLayout>

      <ModalConfirm
        show={showModal}
        text={modalText}
        name={modalName}
        confirm={() => { deletePlayer(playerId); setShowModal(false) }}
        cancel={() => setShowModal(false)}
        confirmText='Supprimer'
      />
      <ModalArchive
        show={showArchiveModal}
        name={modalName}
        actualDrivingTotal={setActualDrivingTotal}
        licenceDate={setLicenceDate}
        licenceAttempts={setLicenceAttempts}
        cancel={() => setShowArchiveModal(false)}
        confirm={() => { archivePlayer(playerId); setShowArchiveModal(false) }}
        enableButton={(actualDrivingTotal.length > 0 && licenceDate.length > 0 && licenceAttempts.length > 0) || false}
      />
    </Bg>
  )
}

const withConnect   = connect(null, null)
const withRefresh   = injectSaga({ key: 'refreshSimuPlayers',   saga: refreshSimuPlayersSaga })
const withLoader    = injectSaga({ key: 'simuPlayersPageLoader', saga: getSimuPlayersSaga })
const withCreate    = injectSaga({ key: 'createArchivePlayer',   saga: createArchivePlayerSaga })
const withDelete    = injectSaga({ key: 'deleteSimuPlayers',     saga: deleteSimuPlayerSaga })
const withDashboard = injectSaga({ key: 'getDashboard',          saga: getDashboardSaga })

export default compose(withRefresh, withLoader, withCreate, withConnect, withDelete, withDashboard)(SimuPlayers)
